<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NGtX5G/images/9781455598304_cover_epub.jpg?1733151275842" alt="This image is the cover for the book Grand Slam, The Boys of Summer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grand Slam, The Boys of Summer
      </h1>
      <p class="bookDescription body article font2">
        <i>New York Times</i> bestselling author of <i>Forever My Girl</i>.<br/><br/> WIN THE GAME. LOSE YOUR HEART. <br/><br/> Everyone knows who I am and that I could have any female fan I want. That's supposed to be the "perk" of playing left field for the Boston Renegades. But I don't want just any woman; I want <i>her</i>.<br/><br/> She should be just another face in the crowd, but I can't stop thinking about the one night we spent together-and her look of regret the morning after.<br/><br/> Because Saylor Blackwell is the kind of woman who haunts a man. Smart, sexy as hell, and one of the best managers in the business. She's every ballplayer's dream woman. And I'd do anything to make things right with her.<br/><br/> I'm done sitting on the bench when it comes to Saylor Blackwell. Time to swing for the fences.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Heidi McLaughlin
      </h2>
      
      <p class="authorDescription body article"><B>Heidi McLaughlin</B> is a <I>New York Times</I> and <I>USA Today</I> bestselling author. Originally from the Pacific Northwest, she now lives in picturesque Vermont with her husband and two daughters. Also renting space in their home is an over-hyper beagle/Jack Russell, Buttercup, a Highland West/mini schnauzer, Jill, and her brother, Racicot. When she's isn't writing stories, you'll find her sitting court-side at her daughters' basketball games. <br><br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4fdfa9ce